import { FC, useCallback, useMemo } from 'react';

import { getJobsByDealId } from '@/utils/stateAccessors';

import { usePermissions } from '@/hooks/usePermissions';

import { isInvoice } from '@payaca/helpers/jobStatusHelper';

import { useSelector } from '@/api/state';
import ResponsiveViewWrapper from '@payaca/components/responsiveViewWrapper/ResponsiveViewWrapper';
import TitledContentPanel from '@payaca/components/titledContentPanel/TitledContentPanel';
import { InvoicesPermissions } from '@payaca/permissions/invoices/invoices.permissions';
import DealListedJobsTable from '../dealListedJobsTable/DealListedJobsTable';
import './DealProposalsInvoices.sass';

interface Props {
  dealId: number;
}

export const DealProposalsInvoices: FC<Props> = ({ dealId }: Props) => {
  const { userHasRequiredPermission } = usePermissions();
  const canViewInvoices = userHasRequiredPermission([
    InvoicesPermissions.GET_INVOICES,
  ]);

  const jobs = useSelector((state) => {
    return getJobsByDealId(state, dealId);
  });

  const proposals = useMemo(() => {
    return jobs?.filter((x) => !isInvoice(x.status));
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has unnecessary dependency: jobs.length
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has unnecessary dependency: jobs.length
  }, [jobs, jobs?.length]);

  const invoices = useMemo(() => {
    return jobs?.filter((x) => isInvoice(x.status));
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has unnecessary dependency: jobs.length
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has unnecessary dependency: jobs.length
  }, [jobs, jobs?.length]);

  const sectionTitle = useCallback(
    (title: string) => (
      <div className="deal-overview-section-title">
        <h3>{title}</h3>
      </div>
    ),
    []
  );

  return (
    <ResponsiveViewWrapper
      downBreakpointSm={900}
      downBreakpointXs={600}
      className="deal-proposals-invoices v1"
    >
      <div className="deal-proposals-invoices-inner">
        {/* Proposals section */}
        <TitledContentPanel
          title={sectionTitle('Proposals')}
          className={!proposals?.length ? 'empty-content' : ''}
        >
          {proposals?.length ? (
            <DealListedJobsTable dealId={dealId} jobs={proposals} />
          ) : (
            <></>
          )}
        </TitledContentPanel>
        {/* Invoices section — hidden from roles without invoice access */}
        {canViewInvoices && (
          <TitledContentPanel
            title={sectionTitle('Invoices')}
            className={!invoices?.length ? 'empty-content' : ''}
          >
            {invoices?.length ? (
              <DealListedJobsTable dealId={dealId} jobs={invoices} />
            ) : (
              <></>
            )}
          </TitledContentPanel>
        )}
      </div>
    </ResponsiveViewWrapper>
  );
};
